import { useRef } from "react";
export default function usePrevious(value) {
    const ref = useRef();
    const { current } = ref;
    ref.current = value;
    return current;
}
//# sourceMappingURL=usePrevious.js.map